import { useUrlBuilder } from '@/composables/url-builder/index.ts'

export function getEcommerceUrl (env) {
  const url = env.VUE_APP_ECOMMERCE_URL ?? window.location.origin.replace('://', '://store.')

  return useUrlBuilder(url).removeTrailingSlash().build()
}
